import axios from "axios";

export const getDeviceDetailAPI = async deviceId => {
  let response = await axios({
    url: `/api/v2/device`,
    method: "GET",
    params: {
      device_id: deviceId
    }
  });
  return response.data;
};
